import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Stack, styled, Typography } from '@mui/material'
import type { FC } from 'react'

import type { BenefitsGroupDto } from '@hcr/api/optimizely'
import { COLORS, ICONS, LinkUnstyled, unit } from '@hcr/ui'

import { Path } from '../../../../../../../../models/navigation'
import { to } from '../../../../../../../../utils/navigation'

interface BenefitPreviewProps {
  benefit: BenefitsGroupDto['content'][number]
}

export const getBenefitLinkElementId = (benefitId: number) => `benefit-link-${benefitId}`

export const BenefitPreview: FC<BenefitPreviewProps> = ({ benefit }) => {
  return (
    <Wrapper>
      <BenefitLink
        id={getBenefitLinkElementId(benefit.benefitId)}
        to={to([Path.OwnerBenefitDetails, { benefitId: String(benefit.benefitId) }])}
        preventScrollReset
      >
        <Stack direction='column'>
          <Typography variant='headlineExtraSmall' color={COLORS.burgundi[500]}>
            {benefit.title}
          </Typography>
          <Subtitle variant='labelM'>{benefit.subtitle}</Subtitle>
        </Stack>
        <IconWrapper>
          <FontAwesomeIcon size={'lg'} icon={ICONS.farChevronRight} aria-hidden='true' />
        </IconWrapper>
      </BenefitLink>
    </Wrapper>
  )
}

const Subtitle = styled(Typography)`
  letter-spacing: 0;
` as typeof Typography

const Wrapper = styled(Box)`
  margin-left: ${unit(4)};
  margin-right: ${unit(4)};

  &:not(:last-child) {
    border-bottom: ${unit(0.25)} dashed ${COLORS.vaalea[800]};
  }
`

const BenefitLink = styled(LinkUnstyled)`
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: space-between;
  gap: ${unit(6)};
  padding-top: ${unit(3.5)};
  padding-bottom: ${unit(3.5)};
  cursor: pointer;
`

const IconWrapper = styled(Box)`
  padding-top: ${unit(2)};
  padding-rigth: ${unit(2)};
`
